import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { type ReactNode, useMemo } from 'react'
import { createAppTheme } from '../theme'
import { useAppContext } from '../hooks/useAppContext'
import { AppContextProvider } from './AppContext'

const ThemeRegistry = ({ children }: { children: ReactNode }) => {
  const {
    state: { themeMode },
  } = useAppContext()
  const theme = useMemo(() => createAppTheme(themeMode), [themeMode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <AppContextProvider>
      <ThemeRegistry>{children}</ThemeRegistry>
    </AppContextProvider>
  )
}
